import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "z-10 sticky top-20 md:top-26 md:grid md:grid-flow-col md:mr-4" }
const _hoisted_2 = { class: "md:col-span-4 md:max-w-xs lg:w-60 text-gray-700 dark:bg-gray-900 bg-white\n    rounded-3xl shadow-lg" }
const _hoisted_3 = { class: "hidden md:block flex-shrink-0 px-6 py-3 flex flex-row items-center justify-between" }
const _hoisted_4 = { class: "text-2xl font-semibold tracking-widest bp-font rounded-lg\n        dark-mode:text-white focus:outline-none focus:shadow-outline" }
const _hoisted_5 = { class: "rounded-lg hidden rounded-lg focus:outline-none focus:shadow-outline" }
const _hoisted_6 = {
  id: "mobile-menu",
  class: "md:hidden",
  style: {"overflow":"hidden"}
}
const _hoisted_7 = {
  class: "p-4 flex justify-between items-center h-14 md:h-0",
  style: {"overflow":"hidden"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DefaultIcon = _resolveComponent("DefaultIcon")
  const _component_Default_icon = _resolveComponent("Default-icon")
  const _component_HeaderItem = _resolveComponent("HeaderItem")
  const _component_SidebarItem = _resolveComponent("SidebarItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("a", _hoisted_4, _toDisplayString(_ctx.$t("nav.SidebarProfile.nickname")), 1),
        _createVNode("button", _hoisted_5, [
          _withDirectives(_createVNode(_component_DefaultIcon, {
            icon: "menu_open_icon",
            "icon-color": "red",
            onClick: _ctx.open
          }, null, 8, ["onClick"]), [
            [_vShow, !_ctx.showMenu]
          ]),
          _withDirectives(_createVNode(_component_Default_icon, {
            icon: "menu_close_icon",
            "icon-color": "red",
            onClick: _ctx.close
          }, null, 8, ["onClick"]), [
            [_vShow, _ctx.showMenu]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_HeaderItem, {
            "css-class": "flex-none text-gray-700",
            "item-color-off": "text-gray-300 dark:text-gray-600",
            "item-icon-pre": "share_icon",
            "item-width": "auto",
            link: "/profile/shared"
          }),
          _createVNode(_component_HeaderItem, {
            "css-class": "flex-none text-gray-700",
            "item-color-off": "text-gray-300 dark:text-gray-600",
            "item-icon-pre": "subscribe_icon",
            "item-text": "",
            "item-width": "auto",
            link: "/profile/subscribed"
          }),
          _createVNode(_component_HeaderItem, {
            "css-class": "flex-none text-gray-700",
            "item-color-off": "text-gray-300 dark:text-gray-600",
            "item-icon-pre": "settings_icon",
            "item-text": "",
            "item-width": "auto",
            link: "/profile/settings"
          }),
          _createVNode(_component_HeaderItem, {
            "css-class": "flex-none text-gray-700",
            "item-color-off": "text-gray-300 dark:text-gray-600",
            "item-icon-pre": "notification_icon",
            "item-text": "",
            "item-width": "auto",
            link: "/profile/notifications"
          })
        ])
      ]),
      _createVNode("nav", {
        class: ["flex-grow md:block px-2 pb-4 md:pb-0\n      md:overflow-y-auto", {'hidden': !_ctx.showMenu, '': _ctx.showMenu}]
      }, [
        _createVNode(_component_SidebarItem, {
          "item-text": _ctx.$t('nav.SidebarProfile.sharedTitle'),
          "css-class": "flex-1",
          "item-icon-pre": "share_icon",
          link: "/profile/shared",
          "show-item": ""
        }, null, 8, ["item-text"]),
        _createVNode(_component_SidebarItem, {
          "item-text": _ctx.$t('nav.SidebarProfile.ordersTitle'),
          "css-class": "flex-1",
          "item-icon-pre": "share_icon",
          link: "/profile/orders",
          "show-item": ""
        }, null, 8, ["item-text"]),
        _createVNode(_component_SidebarItem, {
          "item-text": _ctx.$t('nav.SidebarProfile.subscribedTitle'),
          "css-class": "flex-1",
          "item-icon-pre": "subscribe_icon",
          link: "/profile/subscribed"
        }, null, 8, ["item-text"]),
        _createVNode(_component_SidebarItem, {
          "item-text": _ctx.$t('nav.SidebarProfile.settingsTitle'),
          "css-class": "flex-1",
          "item-icon-pre": "settings_icon",
          link: "/profile/settings"
        }, null, 8, ["item-text"]),
        _createVNode(_component_SidebarItem, {
          "item-text": _ctx.$t('nav.SidebarProfile.notificationsTitle'),
          "css-class": "flex-1 md:mb-72",
          "item-icon-pre": "notification_icon",
          link: "/profile/notifications"
        }, null, 8, ["item-text"]),
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16
      ], 2)
    ])
  ]))
}